function Taiwan({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2266)">
  <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C5.49563 10.5044 10.1565 5.8435 16 0C24.8365 0 32 7.1635 32 16Z" fill="#D80027"/>
  <path d="M16 16C16 7.1635 16 6.12175 16 0C7.1635 0 0 7.1635 0 16H16Z" fill="#0052B4"/>
  <path d="M13.913 9.36358L11.9589 10.2828L12.9994 12.1753L10.8776 11.7693L10.6087 13.9128L9.13082 12.3363L7.65282 13.9128L7.38401 11.7693L5.26213 12.1751L6.30263 10.2827L4.34863 9.36358L6.30269 8.44452L5.26213 6.55202L7.38394 6.95795L7.65288 4.81445L9.13082 6.39095L10.6088 4.81445L10.8776 6.95795L12.9995 6.55202L11.9589 8.44458L13.913 9.36358Z" fill="#F0F0F0"/>
  <path d="M9.13115 12.3414C10.776 12.3414 12.1095 11.008 12.1095 9.36308C12.1095 7.7182 10.776 6.38477 9.13115 6.38477C7.48627 6.38477 6.15283 7.7182 6.15283 9.36308C6.15283 11.008 7.48627 12.3414 9.13115 12.3414Z" fill="#0052B4"/>
  <path d="M9.13088 10.9504C8.25582 10.9504 7.54395 10.2384 7.54395 9.36337C7.54395 8.4883 8.25588 7.77637 9.13088 7.77637C10.0059 7.77637 10.7179 8.4883 10.7179 9.36337C10.7178 10.2384 10.0058 10.9504 9.13088 10.9504Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Taiwan;
